import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/queryClient";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import StartupErrorBoundary from "./components/StartupErrorBoundary";
import LoadingScreen from "./components/LoadingScreen";

if (__BUILD_VERSION__ === "dev") {
  console.log("[init] App mounted, creating router");
}

const router = createRouter({
  routeTree,
  defaultPreload: "render",
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

if (__BUILD_VERSION__ === "dev") {
  console.log("[init] Router created, rendering root");
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <StartupErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <React.Suspense fallback={<LoadingScreen />}>
          <RouterProvider router={router} />
        </React.Suspense>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </StartupErrorBoundary>
  </React.StrictMode>,
);
